import { SessionDialog } from "../dialogs/session-dialog";
import { IncomingByeRequest } from "../messages/methods/bye";
import { IncomingRequestDelegate } from "../messages/incoming-request";
import { IncomingRequestMessage } from "../messages/incoming-request-message";
import { NonInviteServerTransaction } from "../transactions/non-invite-server-transaction";
import { UserAgentServer } from "./user-agent-server";

/**
 * BYE UAS.
 * @public
 */
export class ByeUserAgentServer extends UserAgentServer implements IncomingByeRequest {
  constructor(dialog: SessionDialog, message: IncomingRequestMessage, delegate?: IncomingRequestDelegate) {
    super(NonInviteServerTransaction, dialog.userAgentCore, message, delegate);
  }
}
